<template>
	<div class="root">
		<div class="content">
			<h2>模拟OpenApi流程</h2>
			<div style="padding:10px 0px;">
				<el-button type="primary"  @click="getToken">获取token</el-button>
				<p>{{token}}</p>
			</div>
			<div style="padding:10px 0px;width:30%">
				<el-form ref="form" :model="form" label-width="80px">
					<el-form-item label="商户ID">
						<el-input v-model="form.shopId"></el-input>
					</el-form-item>
					<el-form-item label="商户名称">
						<el-input v-model="form.shopName"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div style="padding:10px 0px;">
				<el-button type="primary" @click="getTransferUrl">获取中转页URL和流水号</el-button>
				<p>{{serialNumber}}</p>
			</div>
			<div style="padding:10px 0px;">
				<el-button type="primary" @click="getThirdPartyParameter">通过流水号获取参数</el-button>
				<p style="padding-bottom:10px;color:#F56C6C">用于查看传的参数是否正确，此按钮与下一按钮调同一个接口，不能同时使用，流水号会失效</p>
				<p>{{jsonStr}}</p>
			</div>
			<div style="padding:10px 0px;">
				<el-button type="primary" @click="goTransferUrl">跳转测试</el-button>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'order-test',
	data (){
		return {
			token: '',
			form: {
				shopId: '2235590', // 商铺ID
				shopName: '商铺001', // 商铺名
			},
			serialNumber: '',
			jsonStr: '',
		}
	},
	mounted() {
		this.$bus.$emit('ready');
	},
	methods: {
		getToken() {
			this.$ajax({
        url: '/api/getToken',
				method: 'post',
				data: {},
        directAjax: true
      }).then(rs => {
				console.log(rs);
				if(rs.success){
					this.token = rs.data.data.token
				}
      })
		},
		getTransferUrl(){
			this.$ajax({
        url: '/api/getTransferUrl',
				method: 'post',
				data: { jsonStr: this.form, token: this.token },
        directAjax: true
      }).then(rs => {
				console.log(rs);
				if(rs.success){
					this.serialNumber = rs.data.data.url.split('=')[1]
				}
      })
		},
		getThirdPartyParameter(){
			this.$ajax({
        url: '/api/getThirdPartyParameter',
				method: 'post',
				data: { serialNumber: this.serialNumber },
        directAjax: true
      }).then(rs => {
				console.log(rs);
				if(rs.success){
					this.jsonStr = rs.data.data.parametersJsonStr;
					this.$storage.set('thirdPartyInfo', rs.data.data.parametersJsonStr);
				}
      })
		},
		goTransferUrl(){
			console.log(window.location.origin)
			let transferUrl = window.location.origin + '/openapi/orderInstallment/entity?serialNumber=' + this.serialNumber
			window.location.href = transferUrl;
		}
	}
}
</script>
<style lang="less" scoped>
@import "..\..\..\global\css\mixin\mixin.less";
.content{
	width: 100%;
	padding:30px;
	h2{
		line-height: 50px;
		height: 50px;
		font-size: 24px;
	}
	p{
		padding-top: 20px;
	}
}
</style>


// WEBPACK FOOTER //
// test.vue?50a44ad4